/*
 * assets/paycron.js
 *
 * Drives every .paycron-pay-now button rendered by snippets/paycron-button.liquid.
 *
 * The listener is delegated off `document`, so it keeps working when the cart
 * drawer or the cart page section is re-rendered by the Section Rendering API
 * (quantity change, item removal) - there is nothing to re-bind.
 *
 * On click it fetches a fresh /cart.js and POSTs the raw JSON to
 * transact.php, which expects: trasactionkey, cartcontent, customeremail.
 */
(function () {
  'use strict';

  var busy = false;

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var button = target.closest('.paycron-pay-now');
    if (!button) return;

    event.preventDefault();
    if (busy) return;
    busy = true;

    var label = button.textContent;
    button.disabled = true;
    button.textContent = 'Please wait…';

    fetchCart()
      .then(function (cartJson) {
        var cart = JSON.parse(cartJson);
        if (!cart.item_count) throw new Error('Cart is empty');
        submit(button, cartJson);
      })
      .catch(function (error) {
        busy = false;
        button.disabled = false;
        button.textContent = label;
        console.error('[paycron]', error);
        window.alert('We could not start checkout. Please try again.');
      });
  });

  function fetchCart() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

    return fetch(root.replace(/\/$/, '') + '/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    }).then(function (response) {
      if (!response.ok) throw new Error('cart.js returned ' + response.status);
      return response.text();
    });
  }

  function submit(button, cartJson) {
    var form = document.createElement('form');
    form.method = 'POST';
    form.action = button.getAttribute('data-paycron-endpoint');
    form.style.display = 'none';

    addField(form, 'trasactionkey', button.getAttribute('data-paycron-key'));
    addField(form, 'cartcontent', cartJson);
    addField(form, 'customeremail', button.getAttribute('data-paycron-email') || '');

    document.body.appendChild(form);
    form.submit();
  }

  function addField(form, name, value) {
    var input = document.createElement('input');
    input.type = 'hidden';
    input.name = name;
    input.value = value;
    form.appendChild(input);
  }
})();